module.exports = __webpack_public_path__ + "img/ekyc2-completed@2x.5979fb64.png";